<template>
  <TButtonGroup>
    <TGroupButton
      data="dir-ltr"
      data-testid="tiptap-dir-ltr"
      tooltip="Left to right"
      small
      toggle
      :active="isDirection('ltr')"
      :inverse="inverse"
      @button-clicked="setDirection('ltr')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        width="20"
        height="20"
        fill="currentColor"
      >
        <rect x="3" y="3.25" width="14" height="1.75" rx="0.875" />
        <rect x="3" y="7.25" width="10" height="1.75" rx="0.875" />
        <rect x="3" y="11.25" width="14" height="1.75" rx="0.875" />
        <rect x="3" y="15.4" width="10" height="1.5" rx="0.75" />
        <path d="M12.5 13.4 16.5 16.15 12.5 18.9Z" />
      </svg>
    </TGroupButton>
    <TGroupButton
      data="dir-rtl"
      data-testid="tiptap-dir-rtl"
      tooltip="Right to left"
      small
      toggle
      :active="isDirection('rtl')"
      :inverse="inverse"
      @button-clicked="setDirection('rtl')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        width="20"
        height="20"
        fill="currentColor"
      >
        <rect x="3" y="3.25" width="14" height="1.75" rx="0.875" />
        <rect x="7" y="7.25" width="10" height="1.75" rx="0.875" />
        <rect x="3" y="11.25" width="14" height="1.75" rx="0.875" />
        <rect x="7" y="15.4" width="10" height="1.5" rx="0.75" />
        <path d="M7.5 13.4 3.5 16.15 7.5 18.9Z" />
      </svg>
    </TGroupButton>
  </TButtonGroup>
</template>

<script lang="ts" setup>
import { Editor } from "@tiptap/core";
import { TButtonGroup, TGroupButton } from "@topol/twig-ui";

const props = defineProps<{
  editor: Editor;
  inverse?: boolean;
}>();

// The textDirection core extension (enabled with "auto" in TipTapInlineEditor)
// puts a `dir` attribute on every block node. "auto" is the default, so a block
// only counts as explicitly LTR/RTL once the user has overridden it here.
function isDirection(direction: "ltr" | "rtl") {
  return props.editor.isActive({ dir: direction });
}

// Clicking the active button clears the override and hands the block back to
// auto-detection, which is how the editor behaves everywhere else for toggles.
function setDirection(direction: "ltr" | "rtl") {
  if (!props.editor) return;
  if (isDirection(direction)) {
    props.editor.chain().focus().unsetTextDirection().run();
    return;
  }
  props.editor.chain().focus().setTextDirection(direction).run();
}
</script>
